module.exports = __webpack_public_path__ + "img/middle_5.94cbf178.png";